module.exports = __webpack_public_path__ + "static/img/bg_queenTi.7dd9962.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/queenTi/bg_queenTi.png
// module id = kliy
// module chunks = 0